import {PagingPayload} from '../constants';
import {IWrapper} from '../types';
import {
  GetLoanRequestsResponse,
  ILoanRequest,
  PostLoanRequestResponse,
  LoanRequestPayload,
} from '../types/endpoints';

/**
 * LoanRequestEndpoint class implements ILoanRequest interface
 */
class LoanRequestEndpoint implements ILoanRequest {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Post new loan request
   * @param data
   */
  public postLoanRequest(
    data: LoanRequestPayload,
  ): Promise<PostLoanRequestResponse> {
    return this.wrapper.post<PostLoanRequestResponse>('/v1/LoanRequest', {
      data,
    });
  }

  /**
   * Get loan requests
   */
  public getLoanRequests(): Promise<GetLoanRequestsResponse> {
    return this.wrapper.get<GetLoanRequestsResponse>(
      '/v1/LoanRequest',
      PagingPayload,
    );
  }
}

export default LoanRequestEndpoint;
